import { render, staticRenderFns } from "./OperaGoodsLabelsWindow.vue?vue&type=template&id=61a52309&scoped=true&"
import script from "./OperaGoodsLabelsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsLabelsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsLabelsWindow.vue?vue&type=style&index=0&id=61a52309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a52309",
  null
  
)

export default component.exports